/** Sum of the premium surcharge for whichever protein option is currently
 *  selected on a cart line. Storefront is a la carte, so this uses each
 *  option's `priceALaCarte` (falling back to the subscription `priceSubscription`
 *  only if a variant hasn't had its a la carte price set in Airtable yet). */
export function getPremiumSurcharge(cartLine) {
  const proteinOptions = cartLine?.proteinOptions || [];
  return proteinOptions
    .filter((o) => o.isActive)
    .reduce((sum, o) => sum + (Number(o.priceALaCarte) || Number(o.priceSubscription) || 0), 0);
}

/** Effective per-unit price for a cart line: base dish price (`cartLine.price`,
 *  unrelated to protein pricing) + any premium protein surcharge from the
 *  currently selected substitution. */
export function getLineUnitPrice(cartLine) {
  return (Number(cartLine?.price) || 0) + getPremiumSurcharge(cartLine);
}
